import * as React from "react";

import { ShadowPricesDto } from "core/backend/data";
import { MultiSelectItem } from "components/multiselect";
import TDatetime from "components/TDatetime";

interface OwnProps {
    dto: ShadowPricesDto;
    left: number;
    hubs: MultiSelectItem[];
}

const Row = ({ dto, left, hubs }: OwnProps) =>
    <>
        <tr>
            <TDatetime rowSpan={1} date={new Date(dto.dateTimeUtc)} left={left} />
            <td>{dto.tso}</td>
            <td>{dto.cnecName}</td>
            <td>{dto.cnecEic}</td>
            <td>{dto.direction}</td>
            <td>{dto.contName}</td>
            <td>{dto.branchEic}</td>

            <td>{dto.shadowPrice}</td>
            <td>{dto.ram}</td>
            <td>{dto.imax}</td>
            <td>{dto.fmax}</td>
            <td>{dto.frm}</td>
            <td>{dto.fref}</td>
            <td>{dto.f0core}</td>
            <td>{dto.f0all}</td>
            <td>{dto.fuaf}</td>
            <td>{dto.amr}</td>
            <td>{dto.ltaMargin}</td>
            <td>{dto.cva}</td>
            <td>{dto.iva}</td>
            <td>{dto.ftotalLtn}</td>
            <td>{dto.minRamFactor}</td>

            <td>{dto.maxZ2ZPtdf}</td>
            <td>{dto.hubFrom}</td>
            <td>{dto.hubTo}</td>
            {hubs.map((hub) => <td key={hub.id}>{eval("dto.hub_" + hub.id.toUpperCase())}</td>)}
        </tr>
    </>

export default Row;